/* ============================================================
   Loriatech Motion — global IntersectionObserver
   The .lt-motion-ready class is added by an inline script in
   theme.liquid (before CSS paints) so there is no flash.
   This file only handles the scroll-triggered reveal.
   ============================================================ */

(function () {
  'use strict';

  var SELECTOR = '[data-lt-reveal]';

  function revealAll() {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  function prefersReduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function init() {
    if (prefersReduced() || !('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.15,
      rootMargin: '0px 0px -20% 0px'
    });

    document.querySelectorAll(SELECTOR).forEach(function (el) {
      var rect = el.getBoundingClientRect();
      // Already in view on load → reveal next frame
      if (rect.top < window.innerHeight * 0.9 && rect.bottom > 0) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { el.classList.add('is-visible'); });
        });
        return;
      }
      io.observe(el);
    });

    // Shopify theme editor: re-reveal on section reload
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', revealAll);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
